const captureExceptionInSentry = (errorMsg: string) => {
  // add amplitude event
  console.warn(errorMsg);
};

export { captureExceptionInSentry };
